import { defineStore } from 'pinia';
import getters from './getters';
import actions from './actions';
function initState() {
    return {
        list: [],
        currentList: [],
        startIndex: 0
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions
});
